import { graphql } from "@/graphql/codegen"

graphql(`
  fragment PayFileListFields on PayFile {
    payFileId
    referenceNumber
    fromDate
    type
    status
    totalAmount
    paymentCount
    latestLog {
      payFileLogId
      event
      description
    }
    invoiceLines {
      amount
      invoice {
        invoiceId
        invoiceNumber
        invoiceType
        accountingPeriod
        createdOn
        dueDate
        scheduledPayDate
        paymentMethod
        printedCheck
        status
        paidDate
        vendorCompany {
          companyId
          name
          publicId
          externalSystemId
          types
          billingLocation {
            locationId
            address1
            address2
            city
            regionIsoCode
            postalCode
            countryIsoCode
            country {
              name
            }
          }
        }
      }
    }
  }
`)
